export const environment = {
  production: false,
  baseUrl: 'https://api-services.dev02.1placedessaisons.com/dev02',
  apiBasePath: 'mass-mailing-campaign/v1',
  // Host suffix a documentValidate PDF presigned URL must carry (S3, virtual-hosted style) before
  // the preview dialog trusts it in an iframe — see PdfPreviewDialogComponent.
  pdfPreviewHostSuffix: '.amazonaws.com',
  umApiUrl: 'https://api-services.int.1placedessaisons.com/int/userManagement/v2',
  // Confirmed against eh-api-generic/gsa/distribution-plan-api's README (`## URLS`) and the
  // governed OpenAPI contract's `servers` block. Unlike umApiUrl / referenceDataApiUrl /
  // permissionsApiUrl above, this one is NOT on the INT gateway: distribution-plan-api has a real
  // dev02 deployment of its own (`TARGET_ENVS: dev02 int uatr uatm prod`), so the "dev02 borrows
  // int" convention does not apply here — using int would read the wrong referential.
  // Must stay in sync with mass-mailing-campaign-api's config/dev02.json.
  distributionPlanApiUrl: 'https://api-services.dev02.1placedessaisons.com/dev02/distribution-plan/v1',
  referenceDataApiUrl: 'https://api-services.int.1placedessaisons.com/int/v1',
  permissionsApiUrl: 'https://api-services.int.1placedessaisons.com/int/v3',
  idp: {
    // DEV02 front authenticates against the INT IdP, so the Service Provider is
    // the INT one (AZTUM-35532), not the DEV02 one (AZTUM-35531).
    issuer: 'https://api-services.int.1placedessaisons.com/int/v1/oidc',
    clientId: 'e4d0c6c1-5a2b-4e59-82bf-34aa8803a6c6', // AZTUM-35532
  },
};
